'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Llocales_cldr_NumberPatterns(decimalFormat, percentFormat, currencyFormat) {
  this.vU = null;
  this.vV = null;
  this.vT = null;
  this.vU = decimalFormat;
  this.vV = percentFormat;
  this.vT = currencyFormat;
}
export { $c_Llocales_cldr_NumberPatterns as $c_Llocales_cldr_NumberPatterns };
$p = $c_Llocales_cldr_NumberPatterns.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Llocales_cldr_NumberPatterns;
/** @constructor */
function $h_Llocales_cldr_NumberPatterns() {
}
export { $h_Llocales_cldr_NumberPatterns as $h_Llocales_cldr_NumberPatterns };
$h_Llocales_cldr_NumberPatterns.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$m_s_util_hashing_MurmurHash3$().e7(this, (-889275714), null);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llocales_cldr_NumberPatterns)) {
    var x = this.vU;
    var x$2 = x$0.vU;
    if (((x === null) ? (x$2 === null) : x.f(x$2))) {
      var x$3 = this.vV;
      var x$4 = x$0.vV;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.vT;
      var x$6 = x$0.vT;
      return ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.b = (function() {
  return $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().ah(this);
});
$p.n = (function() {
  return 3;
});
$p.o = (function() {
  return "NumberPatterns";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.vU;
      break;
    }
    case 1: {
      return this.vV;
      break;
    }
    case 2: {
      return this.vT;
      break;
    }
    default: {
      throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Llocales_cldr_NumberPatterns(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.e1)));
}
export { $isArrayOf_Llocales_cldr_NumberPatterns as $isArrayOf_Llocales_cldr_NumberPatterns };
var $d_Llocales_cldr_NumberPatterns = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Llocales_cldr_NumberPatterns, "locales.cldr.NumberPatterns", ({
  e1: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Llocales_cldr_NumberPatterns as $d_Llocales_cldr_NumberPatterns };
